const my_profile = {
  viewMyClubSeacretProfile: "View My ClubSeacret Profile",
  viewMoreDetails: "View More Details",
  verifiedEmail: "Verified Email",
  unverifiedEmail: "Unverified Email",
  balance: "Balance",
  pointsIn: "Points In",
  pointsOut: "Points Out",
  topUp: "Top Up",
  pointsHistoryTable: "Points History Table",
  createdFrom: "Created From",
  createdTo: "Created To",
  selectStatus: "Select status...",
  searchByTitle: "Search by title...",
  offerStatus: "Offer Status",
  selectOfferStatus: "All",
  quotationSent: "Quotation Sent",
  offerInProgress: "Offer In Progress",
  offerAvailable: "Offer Available",
  offerAccepted: "Offer Accepted",
};

export default my_profile;
